import styled from 'styled-components';

export const Title = styled.div`
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  color: ${(props) => (props.theme.theme === 'dark' ? '#ddd' : '#3e3e3e')};
  margin: 0 10px 0 0;

  &.label2 {
    margin: 0 0 0 10px;
  }
`;

export const Content = styled.div`
  /* height: 40px; */
  display: flex;
  align-items: center;
  label {
    position: relative;
    display: flex;
    align-items: center;
    span {
      display: block;
      position: absolute;
      width: 18px;
      height: 18px;
      left: 2px;
      top: 2px;
      background: #fff;
      border-radius: 50%;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);
      transition: 0.2s;
      cursor: pointer;
      pointer-events: none;
    }
    input {
      appearance: none;
      -webkit-appearance: none;
      margin: 0;
      padding: 0;
      display: block;
      line-height: 1;
      cursor: pointer;
      width: 40px;
      height: 22px;
      background: #3d4952;
      border: 0;
      border-radius: 22px;
      vertical-align: middle;
      transition: background 0.2s ease;

      &:checked {
        background-color: #47b972;
      }
      &:checked + span {
        left: 20px;
      }
    }
  }
`;
